export const PointsPerProperty = {
    Attributes: 1,
    Traits: 10,
    Moves: 5,
    GeneticStrength: 1,
    CanEvolve: 20,
};
